import { endpoints } from "config";

export const META_TITLE = "Pantry Shop by PepsiCo.";
export const META_DESCRIPTION =
  "We deliver your favorite snacks & beverages straight to your door. Save time & keep your pantry stocked with all the good stuff.";
export const CANONICAL_URL_BASE = endpoints.web;
export const META_DEFAULT_OG_IMAGE = `${endpoints.cdn}/static-images/pantry-shop-icons/pantryshop-header-hero.png`;
export const PRIMARY_COLOR = `#003069`;
